import { ApplicationVariableOutlineIcon } from './ApplicationVariableOutlineIcon';

/**
 * author: Michael Irigoyen
 * id DF02C215-E96B-40CA-B372-9767965F11D3
 * name application-variable-outline
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/application-variable-outline.svg
 * tags
 * - Developer / Languages 
 */
export const IframeVariableOutlineIcon = ApplicationVariableOutlineIcon;
export default IframeVariableOutlineIcon